import React from 'react'
import Logo from '../assets/logo.jpeg';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const AdminHeader = () => {

    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('username');
        localStorage.removeItem('isLoggedIn', 'true');
        navigate('/');
        window.location.reload();
    }

    return (
        <>
            <section className='bg-light'>
                <div className='container d-flex justify-content-between'>

                    <img src={Logo} className='img-fluid px-2 rounded my-3 me-lg-3 me-2' style={{ height: '3em' }} alt='Admin Logo' />

                    <div className='d-flex my-4'>
                        <Link to='/admin/dashboard' className='text-dark text-decoration-none me-3' >Dashboard</Link>
                        <Link to='/admin/donation-history' className='text-dark text-decoration-none me-3' >Donations</Link>
                        <Link onClick={handleLogout} className='text-dark text-decoration-none me-3' ><i className="fa-solid fa-right-from-bracket"></i></Link>
                    </div>

                </div>
            </section>
        </>
    )
}

export default AdminHeader
